var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSidebarLogoIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2329 24.4658C18.989 24.4658 24.4658 18.989 24.4658 12.2329C24.4658 5.47686 18.989 0 12.2329 0C5.47686 0 0 5.47686 0 12.2329C0 18.989 5.47686 24.4658 12.2329 24.4658ZM12.7837 20.7845C11.4513 20.8541 10.8913 19.3359 11.6696 18.2522C14.3559 14.5119 14.3143 9.46364 11.5667 5.76814L11.1952 5.26847C10.7542 4.67532 11.0613 3.83013 11.7989 3.78187C12.5692 3.73146 13.3451 3.7875 14.1049 3.95042C15.3718 4.22208 16.5597 4.7836 17.577 5.59162C18.5942 6.39963 19.4135 7.43251 19.9716 8.61045C20.5298 9.78839 20.8117 11.0799 20.7957 12.3851C20.7797 13.6904 20.4662 14.9744 19.8794 16.1381C19.2926 17.3018 18.4482 18.314 17.4115 19.0964C16.3748 19.8789 15.1734 20.4107 13.9003 20.6507C13.5305 20.7204 13.1574 20.765 12.7837 20.7845Z",
    fill: "#206FFD"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarLogoIcon);
export default __webpack_public_path__ + "static/media/sidebar-logo-icon.a4f3eacf89a4d96773f891ca5f8101bd.svg";
export { ForwardRef as ReactComponent };